import { RmsBookstoreAddress } from '../../features/checkout/shop-checkout.interface';
import {
  AddressMatchCode,
  AddressValidityCheckInput,
  InternationalAddressVerificationStatus,
} from '../../features/address/interfaces/address-validation.interface';

export function isAddressValid(address: AddressValidityCheckInput): boolean {
  return (
    address.validated === 'Y' ||
    // validate US address
    (address.country &&
      address.country === 'US' &&
      (AddressMatchCode.FullMatch === address.dpvMatchCode ||
        AddressMatchCode.MatchWithoutSecondary === address.dpvMatchCode)) ||
    // validate international address
    address.verificationStatus === InternationalAddressVerificationStatus.Verified ||
    address.verificationStatus === InternationalAddressVerificationStatus.Partial ||
    address.verificationStatus === InternationalAddressVerificationStatus.Ambiguous
  );
}

export const getEmptyErrorMessage = (fieldName: string) => `Please enter a valid ${fieldName}`;

export const getDoubleQuoteErrorMessage = (fieldName: string) =>
  `${fieldName} cannot contain invalid input character "". Please remove and try again.`;

/**
 * Returns the regex pattern to block consecutive double quotes in address form fields.
 */
export function getDoubleQuoteValidationPattern(): string {
  return '^(?!.*"").*$';
}

/**
 * Fixes data on checkout address fields before updating the Redux store.
 *
 * @param payload
 */
export function updateAddressBeforeSave(payload: RmsBookstoreAddress | undefined): RmsBookstoreAddress | undefined {
  if (!payload) {
    return payload;
  }

  const updated = { ...payload };

  if (!updated.lastName) {
    updated.lastName = updated.firstName;
  }

  for (const key of Object.keys(updated)) {
    if (updated[key] && typeof updated[key] === 'string') {
      updated[key] = updated[key].replaceAll('""', '');
    }
  }

  return updated;
}
